import * as React from "react";

import { cn } from "@/src/lib/utils";

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, maxLength, onChange, ...props }, ref) => {
    const [length, setLength] = React.useState(0);
    const _onChange = React.useCallback<
      React.ChangeEventHandler<HTMLTextAreaElement>
    >(
      (ev) => {
        const value = ev.target.value;
        if (maxLength) {
          setLength(value.length);
        }
        onChange?.(ev);
      },
      [onChange, setLength, maxLength]
    );

    React.useEffect(() => {
      if (maxLength && typeof props.value === "string") {
        setLength(props.value.length);
      }
    }, []);

    const textarea = (
      <textarea
        className={cn(
          "flex min-h-[80px] w-full rounded-md border border-input bg-white px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        onChange={_onChange}
        maxLength={maxLength}
        {...props}
      />
    );
    if (maxLength === undefined) {
      return textarea;
    }
    return (
      <div className="relative">
        {textarea}
        <div className="absolute bottom-1 right-1 text-muted-foreground text-xs">
          {length}/{maxLength} characters
        </div>
      </div>
    );
  }
);
Textarea.displayName = "Textarea";

export { Textarea };
